module.exports = __webpack_public_path__ + "static/logo-twitter-83dd2bd29f9900bbf4b4d50f8662d9a8.png";